import React from 'react';
import { Flex, Box, VStack, Center } from '@televet/kibble-ui';
import SurveyCompose from './Compose';
import SurveySettings from './Settings';
import SurveyPreview from './Preview';
import { RadioButtonGroup } from '@televet/kibble-ui/build/components/RadioButtonGroup';
import { SurveyEditorView, useSurveySettingsContext } from '../context/SurveySettingsContext';
import { SurveySettingsActions } from '../context/SurveySettingsReducer';

const SurveyTabContainer = (): JSX.Element => {
  const { currentEditorView, dispatch } = useSurveySettingsContext();
  return (
    <Box display="flex" flexDirection="column" alignItems="center" flex="1 1 auto" overflowY="auto">
      <Flex w="100%" boxShadow="base" py={4} justifyContent="center" zIndex={1}>
        <Center maxW={80}>
          {/* TODO: CU-86dvx98k1 Let's make sure to update the size of these back to sm */}
          <RadioButtonGroup
            label={''}
            onChange={(value): void => dispatch({ type: SurveySettingsActions.SET_SURVEY_EDITOR_VIEW, payload: value })}
            options={[
              {
                label: 'Settings',
                value: SurveyEditorView.Settings,
              },
              {
                label: 'Compose',
                value: SurveyEditorView.Compose,
              },
              {
                label: 'Preview',
                value: SurveyEditorView.Preview,
              },
            ]}
            selected={currentEditorView || SurveyEditorView.Settings}
          />
        </Center>
      </Flex>

      <VStack w="100%" h="100%" overflowY="auto" pb={5}>
        {currentEditorView === SurveyEditorView.Settings && <SurveySettings />}
        {currentEditorView === SurveyEditorView.Compose && <SurveyCompose />}
        {currentEditorView === SurveyEditorView.Preview && <SurveyPreview />}
      </VStack>
    </Box>
  );
};

export default SurveyTabContainer;
